// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"b35af46a","18":"990dc139","33":"ac3dd318","323":"0612823a"}[chunkId] + ".chunk.css";
};